import { ChapterArt } from '../components/ChapterArt';
import { SecondaryButton } from '../components/Buttons';

// Pantalla de gracias (handoff §11.5).
export function ClosingScreen({ onRestart }: { onRestart: () => void }) {
  return (
    <main className="gb-screen gb-screen--transition">
      <div className="gb-transition__art" aria-hidden="true">
        <ChapterArt kind="sun" />
      </div>
      <p className="gb-transition__done">
        <span className="gb-transition__check" aria-hidden="true">
          ✓
        </span>
        Respuestas enviadas
      </p>
      <h1 className="gb-transition__title">Gracias por construir colegio con nosotros</h1>
      <p className="gb-transition__intro">
        Lo que nos contaste sobre la comunicación, el aprendizaje de tu hijo(a) y los servicios del
        colegio alimenta directamente los planes de mejoramiento del semestre y el informe al
        Consejo Directivo. Los resultados y las acciones se comunicarán a las familias al cierre de
        la medición.
      </p>
      <SecondaryButton onClick={onRestart}>Responder por otro hijo(a)</SecondaryButton>
    </main>
  );
}
